function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineComponent, toRefs, h } from '@vue/composition-api';
import "./style/icon.css";
export var IconProps = {
  width: {
    type: [String, Number]
  },
  height: {
    type: [String, Number]
  },
  fill: {
    type: String
  },
  strokeWidth: {
    type: [String, Number],
    "default": ''
  },
  color: {
    type: String,
    "default": ''
  },
  dcolor: {
    type: String,
    "default": ''
  },
  fontSize: {
    type: String,
    "default": ''
  },
  dir: {
    type: String,
    "default": '',
    required: false
  },
  onClick: {
    type: Function,
    required: false
  }
};
/**
 * Icon组件
 */

var Icon = defineComponent({
  name: 'm-icon',
  props: _objectSpread(_objectSpread({}, IconProps), {}, {
    svg: {
      type: String,
      required: true
    }
  }),
  emits: ['click'],
  setup: function setup(props, context) {
    var propsRef = toRefs(props);
    return function () {
      // const strokeRe = /stroke-width="\d+(\.\d+)?"/g;
      // const svg = propsRef.svg;
      // if (propsRef.strokeWidth.value){
      //     svg.value = svg.value.replace(strokeRe, `stroke-width=\"${propsRef.strokeWidth.value}\"`);
      // }
      return h("span", {
        "class": {
          'm-icon': true,
          'm-icon-rotate180': props.dir !== 'rtl' && props.dir !== 'ltr',
          'm-icon-user-dir-rtl': props.dir === 'rtl',
          'm-icon-user-dir-ltr': props.dir === 'ltr'
        },
        "on": {
          "click": function click(e) {
            return context.emit('click', e);
          }
        },
        "style": {
          color: propsRef.color.value ? propsRef.color.value : context.attrs.dcolor,
          fontSize: propsRef.fontSize.value
        },
        "domProps": {
          "innerHTML": propsRef.svg.value
        }
      });
    };
  }
});
export default Icon;